module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/step-registration-done/step-registration-done.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/step-registration-done/step-registration-done.component.scss
// module chunks = main